import { createContext, useContext } from 'react';

import type { NavDrawerContextValue } from './NavDrawerProvider';

export const NavDrawerContext = createContext({} as NavDrawerContextValue);
NavDrawerContext.displayName = 'NavDrawerContext';

export const useNavDrawer = () => useContext(NavDrawerContext);
